import { IApplicationState } from '../../types/redux';

export function getSalesStartHousesString(state: IApplicationState): string {
  return state.newbuilding.salesStartHousesString || '';
}
